import { initializeApp, type FirebaseOptions } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Die Web-Config ist nicht geheim. `firebase deploy` setzt beim Build
// VITE_FIREBASE_PROJECT auf das Zielprojekt (siehe firebase.json).
// `npm run dev` ohne Angabe nutzt Staging, damit lokale Tests nie Live-Daten treffen.
const configs: Record<'production' | 'staging', FirebaseOptions> = {
  production: {
    projectId: "blazio",
    appId: "1:624813868553:web:a4cfa4b7ed2a452124dad8",
    storageBucket: "blazio.firebasestorage.app",
    apiKey: "AIzaSyA-wDPmTWrXLkL2wHq7RiTY5F2p_0ZG2E8",
    authDomain: "blazio.firebaseapp.com",
    messagingSenderId: "624813868553",
    measurementId: "G-X13MD16L2L",
  },
  staging: {
    projectId: "blazio-staging",
    appId: "1:358612232693:web:368f50feeb648f821558bc",
    storageBucket: "blazio-staging.firebasestorage.app",
    apiKey: "AIzaSyAmLji0PtX9m3Njc0kXvheBNvg5rJkQpXo",
    authDomain: "blazio-staging.firebaseapp.com",
    messagingSenderId: "358612232693",
  },
};

const project = import.meta.env.VITE_FIREBASE_PROJECT || (import.meta.env.DEV ? 'blazio-staging' : 'blazio');

export const firebaseEnv: 'production' | 'staging' = project === 'blazio-staging' ? 'staging' : 'production';

const app = initializeApp(configs[firebaseEnv]);
export const auth = getAuth(app);
export default app;
